/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Today_BackInputs */

const en_us2_engagement_today_back = /** @type {(inputs: Engagement_Today_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Good to have you back. Breaks are part of it; today's workout is what counts.`)
};

const pt_br2_engagement_today_back = /** @type {(inputs: Engagement_Today_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que bom ter você de volta. Pausa faz parte; o que conta é o treino de hoje.`)
};

const es_419_engagement_today_back = /** @type {(inputs: Engagement_Today_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué bueno tenerte de vuelta. Las pausas son parte; lo que cuenta es el entrenamiento de hoy.`)
};

const pt_pt2_engagement_today_back = /** @type {(inputs: Engagement_Today_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que bom ter-te de volta. As pausas fazem parte; o que conta é o treino de hoje.`)
};

const fr_fr2_engagement_today_back = /** @type {(inputs: Engagement_Today_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content de te revoir. Les pauses en font partie ; ce qui compte, c'est la séance du jour.`)
};

const de_de2_engagement_today_back = /** @type {(inputs: Engagement_Today_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schön, dass du wieder da bist. Pausen gehören dazu; was zählt, ist das Training heute.`)
};

const it_it2_engagement_today_back = /** @type {(inputs: Engagement_Today_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bentornato. Le pause fanno parte del gioco; conta l'allenamento di oggi.`)
};

/**
* | output |
* | --- |
* | "Good to have you back. Breaks are part of it; today's workout is what counts." |
*
* @param {Engagement_Today_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_today_back = /** @type {((inputs?: Engagement_Today_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Today_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_today_back(inputs)
	if (locale === "es-419") return es_419_engagement_today_back(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_today_back(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_today_back(inputs)
	if (locale === "de-DE") return de_de2_engagement_today_back(inputs)
	if (locale === "it-IT") return it_it2_engagement_today_back(inputs)
	return en_us2_engagement_today_back(inputs)
});
export { engagement_today_back as "engagement.today_back" }